import React from 'react';
import { Alert, Card, Table } from 'react-bootstrap';
import { Dac7ReportResponse } from '../../../common/api/dac7Service';
import { Loader } from '../../../common/components';
import { LOADING_STATUS } from '../../../common/constants';

type PreviousReportsCardProps = {
  loadingStatus: LOADING_STATUS;
  error: string | null;
  reports: Dac7ReportResponse[];
  formatDate: (dateString: string) => string;
  getStatusBadge: (status: string) => React.ReactNode;
};

function PreviousReportsCard({
  loadingStatus,
  error,
  reports,
  formatDate,
  getStatusBadge,
}: PreviousReportsCardProps) {
  return (
    <Card className="bg-white border shadow-none p-24">
      <h5 className="mb-16">Aiemmat raportit</h5>

      {loadingStatus === LOADING_STATUS.LOADING && (
        <div className="text-center py-4">
          <Loader IsLoading />
        </div>
      )}

      {loadingStatus === LOADING_STATUS.FAILED && error && (
        <Alert variant="danger">{error}</Alert>
      )}

      {loadingStatus === LOADING_STATUS.IDLE && reports.length === 0 && (
        <Alert variant="info">
          Ei aiempia DAC7-raportteja. Luo ensimmäinen raportti yllä olevalla
          lomakkeella.
        </Alert>
      )}

      {loadingStatus === LOADING_STATUS.IDLE && reports.length > 0 && (
        <Table striped hover responsive>
          <thead>
            <tr>
              <th>Vuosi</th>
              <th>Viite-ID</th>
              <th>Tila</th>
              <th>Luotu</th>
              <th>Tekijä</th>
              <th>Muistiinpanot</th>
            </tr>
          </thead>
          <tbody>
            {reports.map(report => (
              <tr key={report.id}>
                <td>{report.reportingYear}</td>
                <td>
                  <code>{report.messageRefId}</code>
                </td>
                <td>{getStatusBadge(report.status)}</td>
                <td>
                  Raportti: {formatDate(report.createdAt)}
                  <br />
                  XML: {report.exportedAt ? formatDate(report.exportedAt) : '-'}
                </td>
                <td>
                  Raportti: {report.createdBy || '-'}
                  <br />
                  XML: {report.exportedBy || '-'}
                </td>
                <td>{report.notes || '-'}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </Card>
  );
}

export default PreviousReportsCard;
